// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__pIJH0","header":"ClearentDisclaimer_header__3MT1e","inner":"ClearentDisclaimer_inner__1cbrX"};